import Vue from 'vue';
import { Form101SearchTypeObj } from '@/models/manager/enums/Form101SearchType';
import { eventsHub } from '@/main';
import i18n from '@/lang/lang';

Vue.filter('DD/MM/YYYY', (timeStamp: Date): any => {
  if (timeStamp) {
    const date: any = new Date(timeStamp);
    const month = date.getMonth() + 1;
    const monthStr = (month > 9 ? '' : '0') + month;
    const dayStr = (date.getDate() > 9 ? '' : '0') + date.getDate();
    return (dayStr + '/' + monthStr + '/' + date.getFullYear());
  }
});

Vue.filter('DateWithTime', (timeStamp: Date | string): any => {
  if (typeof timeStamp === 'string') {
    return timeStamp;
  } else if (timeStamp instanceof Date) {
    const date: any = new Date(timeStamp);
    return (
      (date.getDate() > 9 ? ' ' : ' 0') + date.getDate() + '/'
      + date.getMonth() + 1 + '/'
      + date.getFullYear()
      + ' ' + (date.getHours() > 9 ? ' ' : ' 0') + date.getHours()
      + (date.getMinutes() > 9 ? ':' : ':0') + date.getMinutes());
  }
});

Vue.filter('StringDate', (dateStr: string): any => {
  if (dateStr) {
    const year: string = dateStr.substr(0, 4);
    const month: string = dateStr.substr(4, 2);
    const day: string = dateStr.substr(6, 2);
    return day + '/' + month + '/' + year;
  }
});


Vue.filter('StringMonthDate', function(dateStr: string): any {
  if (dateStr) {
    const year: string = dateStr.substr(0, 4);
    const month: string = dateStr.substr(4, 2);
    return i18n.t(`form101.wizard.form101months.${month}`) + ' ' + year;
  }
});
Vue.filter('addComma', (value: number): string => {
  if (isNaN(value)) {
    return '0';
  }
  return value ? value.toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : '0';
});

Vue.filter('dynamicFilter', (value, name, ...args) => {
  return Vue.filter(name)(value, ...args);  // Argument pass-through
});

Vue.filter('filterSearchType', (value: string) => {
  return eventsHub.$t('Form101SearchTypeObj.' + Form101SearchTypeObj[value]);
});

Vue.filter('errorLevel', (value: string) => {
  return '<figure></figure>';
});
